import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import Plyr from 'plyr';

@Component({
  selector: 'app-video-embed',
  templateUrl: './video-embed.component.html',
  styleUrls: ['./video-embed.component.scss']
})
export class VideoEmbedComponent implements OnInit, AfterViewInit {
  player: Plyr;
  options: Plyr.Options = {
    controls: ['play', 'current-time', 'progress', 'download', 'settings', 'fullscreen']
  };
  @Input() videoSources: string;
  @Input() videoTitle: string;
  @Input() customDownloadLink: string;

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    if (!this.customDownloadLink) return;
    this.setDownloadUrl();
  }
  setDownloadUrl(): void {
    this.player['config'].urls.download = this.customDownloadLink;
  }
}
